// extracted by mini-css-extract-plugin
export default {"fieldset":"Fieldset_fieldset__c-WbI","legend":"Fieldset_legend__LIX6L","content":"Fieldset_content__LU4zG"};